interface FetchErrorObject {
    ErrorCode: number;
    ErrorDescription: string;
    URL: string
}

export default class CustomFetchError extends Error {
    ErrorCode: number;
    ErrorDescription: string;
    URL: string;

    constructor(fetchErrorObject: FetchErrorObject, options?: ErrorOptions) {
        super(JSON.stringify(fetchErrorObject, null, 4), options)
        this.ErrorCode = fetchErrorObject.ErrorCode
        this.ErrorDescription = fetchErrorObject.ErrorDescription
        this.URL = fetchErrorObject.URL
    }
}